import { Slider, Typography } from "@material-ui/core";
import { ExpandLessOutlined } from "@material-ui/icons";
import React, { useEffect, useState } from "react";

const toNum = (v) => {
  const n = typeof v === "number" ? v : parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};

/**
 *
 * @param props
 * @param props.classes
 * @param props.label
 * @param props.value
 * @param props.setValue
 * @param props.min
 * @param props.max
 * @param props.step
 * @param props.userPermissions
 * @param props.createSnackbar
 * @returns {JSX.Element|null}
 */

export default function sliderGeneric(props) {
  if (_.isNil(props.value)) {
    return null;
  }

  // Tree-view bases pass livePreview: while dragging, only the playable preview
  // is patched (cheap, SceneDebugger-style); the React state + persist commit
  // fires once on release via onChangeCommitted. Bases without livePreview keep
  // the historical commit-per-tick behaviour.
  const hasLivePreview = _.isFunction(props.livePreview);
  const changeValue = (path, val) => {
    if (hasLivePreview) {
      props.livePreview(path, val);
    } else {
      props.setValue(path, val);
    }
  };
  const commitValue = (path) => (event, val) => {
    if (!hasLivePreview) return;
    if (props.userPermissions["editContent"] === false) return;
    props.setValue(path, val);
  };

  const [x, setX] = useState(_.get(props, "value.x", 0.5));
  const [y, setY] = useState(_.get(props, "value.y", 0.5));
  const [value, setValue] = useState(props.value);
  const [portrait, setPortrait] = useState(_.get(props, "value.portrait", 0.5));
  const [landscape, setLandscape] = useState(_.get(props, "value.landscape", 0.5));
  const [portraitX, setPortraitX] = useState(_.get(props, "value.portrait.x", 0.5));
  const [portraitY, setPortraitY] = useState(_.get(props, "value.portrait.y", 0.5));
  const [landscapeX, setLandscapeX] = useState(_.get(props, "value.landscape.x", 0.5));
  const [landscapeY, setLandscapeY] = useState(_.get(props, "value.landscape.x", 0.5));
  const [portraitWidth, setPortraitWidth] = useState(_.get(props, "value.portrait.width", 0.5));
  const [portraitHeight, setPortraitHeight] = useState(_.get(props, "value.portrait.height", 0.5));
  const [landscapeWidth, setLandscapeWidth] = useState(_.get(props, "value.landscape.width", 0.5));
  const [landscapeHeight, setLandscapeHeight] = useState(_.get(props, "value.landscape.height", 0.5));
  useEffect(() => {
    setPortraitWidth(_.get(props, "value.portrait.width", 0.5));
    setPortraitHeight(_.get(props, "value.portrait.height", 0.5));
    setLandscapeWidth(_.get(props, "value.landscape.width", 0.5));
    setLandscapeHeight(_.get(props, "value.landscape.height", 0.5));
    setPortraitX(_.get(props, "value.portrait.x", 0.5));
    setPortraitY(_.get(props, "value.portrait.y", 0.5));
    setLandscapeX(_.get(props, "value.landscape.x", 0.5));
    setLandscapeY(_.get(props, "value.landscape.y", 0.5));
    setPortrait(_.get(props, "value.portrait", 0.5));
    setLandscape(_.get(props, "value.landscape", 0.5));
    setX(_.get(props, "value.x", 0.5));
    setY(_.get(props, "value.y", 0.5));
    setValue(props.value);
  }, [props.value]);
  function gettingMargin(numberMargin) {
    if (props.tooltip != undefined) {
      if (numberMargin) {
        return numberMargin.toString() + "px";
      }
    } else return (0).toString() + "px";
  }
  function checkPosition(label) {
    if (label.includes("Landscape") || label.includes("Portrait")) {
      if (props.newSetPortrait && label.includes("Portrait")) {
        return true;
      } else if (!props.newSetPortrait && label.includes("Landscape")) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  }

  if (props.editorSubType === "XY_4" || props.editorSubType === "XY_4_FullPath") {
    return (
      <>
        {" "}
        {props.isVisible && !props.y_axis && (
          <div>
            <Typography style={{ marginTop: gettingMargin(props.tooltipLength) }}>{props.label}</Typography>
            {props.newSetPortrait && (
              <div>
                <Typography>Portrait X</Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  className={props.classes.sliderSize}
                  value={toNum(portraitX)}
                  aria-labelledby="labelOffsetX"
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  //step={props.step} min={props.min} max={props.max}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setPortraitX(newValue);
                    changeValue(props.path + ".portrait.x", newValue);
                  }}
                  onChangeCommitted={commitValue(props.path + ".portrait.x")}
                />
                <Typography>Portrait Y</Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  className={props.classes.sliderSize}
                  value={toNum(portraitY)}
                  aria-labelledby="labelOffsetX"
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setPortraitY(newValue);
                    // props.setValue({
                    //     portrait: { x: portraitX, y: newValue },
                    //     landscape: { x: landscapeX, y: landscapeY }
                    // });
                    changeValue(props.path + ".portrait.y", newValue); //
                  }}
                  onChangeCommitted={commitValue(props.path + ".portrait.y")}
                // onDragStop={ (event) => this.props.update(event, control.id, value) }
                />
              </div>
            )}

            {!props.newSetPortrait && (
              <div>
                <Typography>Landscape X</Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  className={props.classes.sliderSize}
                  value={toNum(landscapeX)}
                  aria-labelledby="labelOffsetX"
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setLandscapeX(newValue);
                    // props.setValue({
                    //     portrait: { x: portraitX, y: portraitY },
                    //     landscape: { x: newValue, y: landscapeY }
                    // });
                    changeValue(props.path + ".landscape.x", newValue);
                  }}
                  onChangeCommitted={commitValue(props.path + ".landscape.x")}
                />
                <Typography>Landscape Y</Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  className={props.classes.sliderSize}
                  value={toNum(landscapeY)}
                  aria-labelledby="labelOffsetX"
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  // step={0.001} min={0} max={1}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setLandscapeY(newValue);
                    // props.setValue({
                    //     portrait: { x: portraitX, y: portraitY },
                    //     landscape: { x: landscapeX, y: newValue }
                    // });
                    changeValue(props.path + ".landscape.y", newValue);
                  }}
                  onChangeCommitted={commitValue(props.path + ".landscape.y")}
                />
              </div>
            )}
          </div>
        )}
        {props.isVisible && props.y_axis && (
          <div>
            <Typography>{props.label}</Typography>
            {props.newSetPortrait && (
              <div>
                <Typography>Portrait Y</Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  className={props.classes.sliderSize}
                  value={toNum(portraitY)}
                  aria-labelledby="labelOffsetX"
                  // step={props.step} min={props.min} max={props.max}
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setPortraitY(newValue);
                    changeValue(props.path + ".portrait.y", newValue);
                  }}
                  onChangeCommitted={commitValue(props.path + ".portrait.y")}
                />
              </div>
            )}
            {!props.newSetPortrait && (
              <div>
                <Typography>Landscape Y</Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  className={props.classes.sliderSize}
                  value={toNum(landscapeY)}
                  aria-labelledby="labelOffsetX"
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setLandscapeY(newValue);
                    // props.setValue({
                    //     portrait: { x: portraitX, y: portraitY },
                    //     landscape: { x: landscapeX, y: newValue }
                    // });
                    changeValue(props.path + ".landscape.y", newValue);
                  }}
                  onChangeCommitted={commitValue(props.path + ".landscape.y")}
                />
              </div>
            )}
          </div>
        )}
      </>
    );
  } else if (props.editorSubType == "WHR_2" || props.editorSubType == "WHR_2_FullPath") {
    return (
      <>
        {" "}
        {props.isVisible && (
          <div>
            <Typography style={{ marginTop: gettingMargin(props.tooltipLength) }}>{props.label || "Scale"}</Typography>
            {props.newSetPortrait && (
              <div>
                <Typography>Portrait</Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  className={props.classes.sliderSize}
                  value={toNum(portrait)}
                  aria-labelledby="labelOffsetX"
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setPortrait(newValue);
                    changeValue(props.path + ".portrait", newValue);
                  }}
                  onChangeCommitted={commitValue(props.path + ".portrait")}
                />
              </div>
            )}
            {!props.newSetPortrait && (
              <div>
                <Typography>Landscape</Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  className={props.classes.sliderSize}
                  value={toNum(landscape)}
                  aria-labelledby="labelOffsetX"
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setLandscape(newValue);
                    changeValue(props.path + ".landscape", newValue);
                  }}
                  onChangeCommitted={commitValue(props.path + ".landscape")}
                />
              </div>
            )}
          </div>
        )}
      </>
    );
  } else if (props.editorSubType === "WHR_4" || props.editorSubType === "WHR_4_FullPath") {
    return (
      <>
        {" "}
        {props.isVisible && !props.y_axis && (
          <div>
            <Typography style={{ marginTop: gettingMargin(props.tooltipLength) }}>{props.label}</Typography>
            {props.newSetPortrait && (
              <div>
                <Typography>Portrait Width</Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  className={props.classes.sliderSize}
                  value={toNum(portraitWidth)}
                  aria-labelledby="labelOffsetX"
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setPortraitWidth(newValue);
                    changeValue(props.path + ".portrait.width", newValue);
                  }}
                  onChangeCommitted={commitValue(props.path + ".portrait.width")}
                />
                <Typography>Portrait Height</Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  className={props.classes.sliderSize}
                  value={toNum(portraitHeight)}
                  aria-labelledby="labelOffsetX"
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setPortraitHeight(newValue);
                    changeValue(props.path + ".portrait.height", newValue); //
                  }}
                  onChangeCommitted={commitValue(props.path + ".portrait.height")}
                // onDragStop={ (event) => this.props.update(event, control.id, value) }
                />
              </div>
            )}

            {!props.newSetPortrait && (
              <div>
                <Typography>Landscape Width</Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  className={props.classes.sliderSize}
                  value={toNum(landscapeWidth)}
                  aria-labelledby="labelOffsetX"
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setLandscapeWidth(newValue);
                    changeValue(props.path + ".landscape.width", newValue);
                  }}
                  onChangeCommitted={commitValue(props.path + ".landscape.width")}
                />
                <Typography>Landscape Height</Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  className={props.classes.sliderSize}
                  value={toNum(landscapeHeight)}
                  aria-labelledby="labelOffsetX"
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setLandscapeHeight(newValue);
                    changeValue(props.path + ".landscape.height", newValue);
                  }}
                  onChangeCommitted={commitValue(props.path + ".landscape.height")}
                />
              </div>
            )}
          </div>
        )}
        {props.isVisible && props.y_axis && (
          <div>
            <Typography>{props.label}</Typography>
            {props.newSetPortrait && (
              <div>
                <Typography>Portrait Y</Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  className={props.classes.sliderSize}
                  value={toNum(portraitY)}
                  aria-labelledby="labelOffsetX"
                  // step={props.step} min={props.min} max={props.max}
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setPortraitY(newValue);
                    changeValue(props.path + ".portrait.y", newValue);
                  }}
                  onChangeCommitted={commitValue(props.path + ".portrait.y")}
                />
              </div>
            )}
            {!props.newSetPortrait && (
              <div>
                <Typography>Landscape Y</Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  className={props.classes.sliderSize}
                  value={toNum(landscapeY)}
                  aria-labelledby="labelOffsetX"
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setLandscapeY(newValue);
                    // props.setValue({
                    //     portrait: { x: portraitX, y: portraitY },
                    //     landscape: { x: landscapeX, y: newValue }
                    // });
                    changeValue(props.path + ".landscape.y", newValue);
                  }}
                  onChangeCommitted={commitValue(props.path + ".landscape.y")}
                />
              </div>
            )}
          </div>
        )}
      </>
    );
  } else if (props.editorSubType == "XY_2" || props.editorSubType == "XY_2_FullPath") {
    return (
      <>
        {" "}
        {props.isVisible && (
          <div id={"sliderOriginDiv"} className={props.classes.editorItem}>
            <Typography style={{ marginTop: gettingMargin(props.tooltipLength) }} id="discrete-slider" gutterBottom>
              {_.get(props, "label")}
            </Typography>
            <Typography id="labelOriginX" gutterBottom>
              {"X"}
            </Typography>
            <Slider
              onKeyDown={(event) => {
                event.stopPropagation();
              }}
              style={{ width: "100%" }}
              value={toNum(x)}
              aria-labelledby="labelOriginX"
              valueLabelDisplay="auto"
              step={props.step}
              min={props.min}
              max={props.max}
              onChange={(event, newValue) => {
                if (props.userPermissions["editContent"] === false) {
                  props.createSnackbar(
                    "You do not have permission to update, contact your administrator.",
                    "warning",
                    false
                  );
                  return;
                }
                setX(newValue);
                changeValue(props.path + ".x", newValue);
              }}
              onChangeCommitted={commitValue(props.path + ".x")}
            />
            <Typography id="labelOriginY" gutterBottom>
              {"Y"}
            </Typography>
            <Slider
              onKeyDown={(event) => {
                event.stopPropagation();
              }}
              style={{ width: "100%" }}
              value={toNum(y)}
              aria-labelledby="labelOriginY"
              valueLabelDisplay="auto"
              step={props.step}
              min={props.min}
              max={props.max}
              onChange={(event, newValue) => {
                if (props.userPermissions["editContent"] === false) {
                  props.createSnackbar(
                    "You do not have permission to update, contact your administrator.",
                    "warning",
                    false
                  );
                  return;
                }
                setY(newValue);
                changeValue(props.path + ".y", newValue);
              }}
              onChangeCommitted={commitValue(props.path + ".y")}
            />
          </div>
        )}
      </>
    );
  } else if (props.editorSubType == "singleSliderFullPath") {
    return (
      <>
        {props.isVisible && (
          <div className={props.classes.editorItem}>
            <Typography id="discrete-slider" gutterBottom>
              {_.get(props, "label")}
            </Typography>

            <Slider
              onKeyDown={(event) => {
                event.stopPropagation();
              }}
              style={{ width: "100%" }}
              value={toNum(value)}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              step={props.step}
              min={props.min}
              max={props.max}
              onChange={(event, newValue) => {
                if (props.userPermissions["editContent"] === false) {
                  props.createSnackbar(
                    "You do not have permission to update, contact your administrator.",
                    "warning",
                    false
                  );
                  return;
                }
                setValue(newValue);
                changeValue(props.path, newValue);
              }}
              onChangeCommitted={commitValue(props.path)}
            />
          </div>
        )}
      </>
    );
  } else {
    return (
      <>
        {props.isVisible && (
          <div>
            {checkPosition(_.get(props, "label")) && (
              <div>
                <Typography style={{ marginTop: gettingMargin(props.tooltipLength) }} id="discrete-slider" gutterBottom>
                  {_.get(props, "label")}
                </Typography>
                <Slider
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  style={{ width: "100%" }}
                  value={toNum(value)}
                  aria-labelledby="discrete-slider"
                  valueLabelDisplay="auto"
                  step={props.step}
                  min={props.min}
                  max={props.max}
                  onChange={(event, newValue) => {
                    if (props.userPermissions["editContent"] === false) {
                      props.createSnackbar(
                        "You do not have permission to update, contact your administrator.",
                        "warning",
                        false
                      );
                      return;
                    }
                    setValue(newValue);
                    changeValue(props.path, newValue);
                  }}
                  onChangeCommitted={commitValue(props.path)}
                />
              </div>
            )}
          </div>
        )}
      </>
    );
  }
}
